import {
  type BulkReportMetadataUpdate,
  type ReportFileResponse,
  type ReportMetadataUpdate,
  ReportType,
} from "@mytour/shared";
import axios from "axios";

function bulkUpdateMetadata(payload: BulkReportMetadataUpdate["updates"]) {
  return axios.put("/api/report-files/metadata/bulk", {
    updates: payload,
  });
}

type Suggestions = ReportMetadataUpdate[];

async function allRecommandations() {
  const result = await axios.get<Suggestions>(
    `/api/report-files/metadata/${ReportType.SPECTRUM}/list`
  );
  return result.data;
}

async function fetch5Recommandations() {
  const result = await axios.get<string[]>(
    `/api/report-files/metadata/${ReportType.SPECTRUM}?search=`
  );
  return result.data.slice(0, 5);
}

async function reportsFor(serviceTargetId: string) {
  const result = await axios.get<ReportFileResponse[]>(`/api/report-files/${serviceTargetId}`);
  if (!result.data) {
    return undefined;
  }
  return result.data;
}

export const reportApiService = {
  reportsFor,
  bulkUpdateMetadata,
  allRecommandations,
  fetch5Recommandations,
};
